import { findApplicant } from '@hc-frontend/business'

function getApplicantFirstName(hcStorage) {
  const applicant = findApplicant(hcStorage.members)
  return hcStorage.contact.first_name || applicant.firstName || ''
}

export default getApplicantFirstName
